// src/pages/admin/viewHistory/serviceQty.js — pure quantity/date-range calculations used by
// ViewHistoryTab's exports. No React state; every function is a function of its arguments.
import { firstDefined, hasValue, toNumber, toDate } from "./helpers";

export const inferServiceQty = (item = {}, jobData = {}, loadDocs = []) => {
  const direct = firstDefined(
    item.serviceBinQty,
    item.qtyBinsCollected,
    item.binQty,
    item.quantity,
    item.totalBinsCollected,
    item.binsCollected,
    item.billableBinQty,
    item.jobTypeBinQty,
    jobData.serviceBinQty,
    jobData.qtyBinsCollected,
    jobData.binQty,
    jobData.quantity,
    jobData.totalBinsCollected,
    jobData.binsCollected,
    jobData.billableBinQty,
    jobData.jobTypeBinQty,
    jobData?.serviceDetails?.binQty,
    jobData?.serviceDetails?.quantity
  );
  if (hasValue(direct)) return toNumber(direct);

  const sumBins = (rows = []) =>
    Array.isArray(rows)
      ? rows.reduce(
          (sum, row) =>
            sum +
            toNumber(
              row?.qty ??
                row?.quantity ??
                row?.count ??
                row?.units ??
                row?.total ??
                row?.bins ??
                row?.binQty ??
                0
            ),
          0
        )
      : 0;

  const deliveries = Array.isArray(jobData.deliveries) ? jobData.deliveries : [];
  const pickups = Array.isArray(jobData.pickups) ? jobData.pickups : [];
  const emptyLoadsBase = Array.isArray(jobData.emptyLoads) ? jobData.emptyLoads : [];
  const loadRows = Array.isArray(loadDocs) ? loadDocs : [];
  const ledgerEmptyLoads = loadRows.map((l) => ({
    qty: l?.qty,
    quantity: l?.quantity,
    count: l?.count,
    units: l?.units,
    total: l?.total,
    bins: l?.bins,
    binQty: l?.binQty,
  }));

  const delivered =
    sumBins(item.deliveredBins) ||
    sumBins(jobData.deliveredBins) ||
    sumBins(deliveries);
  const pickedUp =
    sumBins(item.pickedUpBins) ||
    sumBins(jobData.pickedUpBins) ||
    sumBins(pickups);
  const emptied =
    sumBins(item.wasteEntries) ||
    sumBins(jobData.wasteEntries) ||
    sumBins(item.emptiedBins) ||
    sumBins(jobData.emptiedBins) ||
    sumBins(item.binActions) ||
    sumBins(jobData.binActions);

  const emptyLoadTotals = jobData?.emptyLoadTotals || {};
  const emptyLoadTotalUnits = toNumber(
    firstDefined(
      emptyLoadTotals.totalUnits,
      emptyLoadTotals.units,
      emptyLoadTotals.total,
      jobData.totalEmptied,
      jobData.totalEmptyUnits
    )
  );
  const emptyLoadsQty = sumBins(emptyLoadsBase) || sumBins(ledgerEmptyLoads);

  const derived = Math.max(delivered, pickedUp, emptied, emptyLoadTotalUnits, emptyLoadsQty, 0);
  if (derived > 0) return derived;

  const notesSource = firstDefined(
    jobData.driverNotes,
    item.driverNotes,
    item.description,
    jobData.description,
    ""
  );
  const notesText = String(notesSource || "");
  const binMatch = notesText.match(/(\d+(?:\.\d+)?)\s*(?:x\s*)?bins?\b/i);
  if (binMatch) return toNumber(binMatch[1]);

  return "";
};

export const getDateRangeArray = (from, to) => {
  const dates = [];
  const start = toDate(`${from}T00:00:00`);
  const end = toDate(`${to}T00:00:00`);
  if (!(start instanceof Date) || Number.isNaN(start.getTime())) return dates;
  if (!(end instanceof Date) || Number.isNaN(end.getTime())) return dates;

  const cur = new Date(start);
  while (cur <= end) {
    const y = cur.getFullYear();
    const m = String(cur.getMonth() + 1).padStart(2, "0");
    const d = String(cur.getDate()).padStart(2, "0");
    dates.push(`${y}-${m}-${d}`);
    cur.setDate(cur.getDate() + 1);
  }
  return dates;
};
